export const TRANSLOCO_MATOMO_EVENT_CATEGORY_LANGUAGE = 'Language';
